import { NlpModel } from '@feedyou-ai/feedbot-schema'

import { GenericFormData } from '../../types'
import { FeedbotThunk } from '../../../../store/types'
import { updateBotProperties } from '../../../../actions/bot'
import { featureValueSelector } from '../../../../store/features/selectors'
import { botFlowSelector } from '../../../../store/flow/selectors/botFlowSelector'
import { validateAndFixDuplicateIdsInNlpSettings } from '../../../../features/flowValidation'
import { adjustModelIdToNlpModelIdFormat } from '../../sharedSchemaFragments/nlpSettings/utils'

export const save =
  (formData: GenericFormData): FeedbotThunk =>
  async (dispatch, getState) => {
    const state = getState()
    const flow = botFlowSelector(state)
    const isUniqueIdValidationEnabled = featureValueSelector('UNIQUE_BOT_ID_VALIDATION')(state)

    const newModel = formData as NlpModel
    const existingNlpModels = flow?.nlp?.models || []
    const modelId = adjustModelIdToNlpModelIdFormat(newModel?.id, existingNlpModels)
    const settingsWithAdjustedIds = { models: [{ ...newModel, id: modelId }] }
    // Validation still required for nested objects - adjustModelIdsToNlpModelIdFormat
    // only regenerates ids od models themselves, but not on entities inside models (intents, entities, options)
    const duplicateIdsValidationResult = await validateAndFixDuplicateIdsInNlpSettings(
      settingsWithAdjustedIds,
      !isUniqueIdValidationEnabled
    )

    const { correctedEntity, didValidateSuccessfully } = duplicateIdsValidationResult
    if (didValidateSuccessfully) {
      const models = [...existingNlpModels, ...(correctedEntity.models || [])]
      dispatch(updateBotProperties({ nlp: { ...flow?.nlp, models } }))
    }
  }
